import React, { useState, useEffect } from 'react'; 
import logo from '../Images/kuza-white.svg';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAd, faAdd, faArrowRightFromBracket, faBars, faBell, faClipboardCheck, faCommentSms, faGear, faGift, faQuestionCircle, faScaleBalanced } from '@fortawesome/free-solid-svg-icons';
import profpicHolder from '../Images/profimage.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import { getAuth, onAuthStateChanged,signOut } from "firebase/auth";
import { app } from '../firebase.js';
import defaultProfilePhoto from '../Images/defprofile.png';
import { getFirestore, collection, query, getDocs, doc, updateDoc, serverTimestamp, where } from "@firebase/firestore"; 

//mobile navbar
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas'; 


//icons
import { faHome} from '@fortawesome/free-solid-svg-icons'
import { faUser} from '@fortawesome/free-solid-svg-icons'
import { faUsers} from '@fortawesome/free-solid-svg-icons'
import { faBookmark} from '@fortawesome/free-solid-svg-icons'
import { faBriefcase} from '@fortawesome/free-solid-svg-icons'
import { faCoffee} from '@fortawesome/free-solid-svg-icons'
import { faCalendarDay} from '@fortawesome/free-solid-svg-icons'
import { faUsd} from '@fortawesome/free-solid-svg-icons'
import { faMagic} from '@fortawesome/free-solid-svg-icons'
import { faVideoCamera} from '@fortawesome/free-solid-svg-icons'
import { faBicycle } from '@fortawesome/free-solid-svg-icons';

import PlayIcon from '../Images/android.png' 


function NavBarAccount() {
    const db = getFirestore(app);
    const [loading, setLoading] = useState(true); 
    const [userProfilePicture, setProfilePicture] = useState(defaultProfilePhoto);
    const [loggedInUser, setloggedInUser] = useState(""); 
    const navigate = useNavigate(); // Initialize useNavigate

    //mount stuff here

    const auth = getAuth();
    useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const uid = user.uid;
        const userQuery = query(collection(db, "users"), where("userId", "==", uid));

        try {
          const querySnapshot = await getDocs(userQuery);

          querySnapshot.forEach((docSnapshot) => {
            const userData = docSnapshot.data();
            setloggedInUser(userData.businessName);

            if (userData.profilePic) {
              setProfilePicture(userData.profilePic);
            }
          });

          // Update last login timestamp
          await updateDoc(doc(db, "users", uid), {
            lastLogin: serverTimestamp(),
            lastLoginVia: "Web",
          });

        } catch (error) {
          console.error("Error fetching or updating user data:", error);
        } finally {
          setLoading(false);
        }

      } else {
        navigate("/login", { replace: true });
      }
    });

    return () => unsubscribe(); // Clean up listener
  }, [navigate]);


    function logoutUser(){

        signOut(auth).then(() => {
            // Redirect or navigate to login page after logout
            navigate('/login'); // Change to your desired route
        }).catch((error) => {
            console.error("Error signing out: ", error);
        });

    }

    return (
        <div className='navbar'>
          <Link  className='someUselesLink'></Link>
          <div className='dashMenuIcon'>

          {[false, ].map((expand) => (
            <Navbar key={expand} bg="" className="" expand={expand} >
              <Container fluid>
              
                <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
                <Navbar.Offcanvas className='offcanvasshit'
                  id={`offcanvasNavbar-expand-${expand}`}
                  aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                  placement="start"
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                    <img src={logo} alt="" className='dashnavLogo' />
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body >
                    <Nav className="justify-content-end  flex-grow-1 pe-3">

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/dashboard" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faHome} className="laftNavIcon"/>
                          Dashboard
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/reward-points" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faAdd} className="laftNavIcon"/>
                          Reward Points
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/reedem-points" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faGift} className="laftNavIcon"/>
                          Reedem Points
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/send-sms" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faCommentSms} className="laftNavIcon"/>
                          Send Promotional SMS
                        </Link>
                      </div>

                      <hr/>

                      <div className='footerMenu'>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/settings" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faGear} className="laftNavIcon"/>
                          Settings
                        </Link>
                      </div>


                      

                      <div className='leftLinkCont d-flex align-items-center' onClick={logoutUser}>
                        <div to="/" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faArrowRightFromBracket} className="laftNavIcon"/>
                          Logout
                        </div>
                      </div>

                       <a href='https://play.google.com/store/apps/details?id=com.kuza.points' className='playStoreIcon'>
                            <img src={PlayIcon}/>
                        </a>



                      </div>


                      

                    </Nav>

                  </Offcanvas.Body>
                </Navbar.Offcanvas>
              </Container>
            </Navbar>
          ))}
        </div>

            <div className='navbarTwo'>
                <Link to='/profile' className='signuptext'>
                    {loggedInUser}
                </Link>

                <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic" className="custom-dropdown-toggle">
                        <div className='accountCont'>
                            <FontAwesomeIcon icon={faBars} className="barsIcon"/>
                            <div className='profileCont'>
                            <img src={userProfilePicture || profpicHolder} alt="Profile" />
                            </div>
                        </div>
                    </Dropdown.Toggle> 

                    <Dropdown.Menu>
                        <Dropdown.Item href="/dashboard">Dashboard</Dropdown.Item>
                        <Dropdown.Item href="/profile">My Account</Dropdown.Item>
                        <Dropdown.Item onClick={logoutUser}>Logout</Dropdown.Item>                  
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    );
}

export default NavBarAccount; 